import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import { confirmable } from 'react-confirm';

/** Do not use this component directly. Use it with utils/alertDialog.js instead.
 *  (This might not be the redux way of doing it, but in this case i think it is ok, since the redux way seems overly complex (can't put callbacks in the store, so how to react to ok/cancel, for example).
 */

// See the react-confirm manual: https://www.npmjs.com/package/react-confirm. (Note: This function is a *stateless* react component).
const AlertDialog = ({show, proceed, dismiss, cancel, title, text, options}) => {
    console.log(options);
    return (
        <ReactModal isOpen={show} shouldCloseOnOverlayClick={false} style={modalDialogStyles}>
            <div className="modalDialogContent">
                <h2>{title}</h2>
                <p style={Object.assign({paddingTop:"14px", paddingBottom:"20px", maxHeight:"400px", overflowY: "auto"}, options.textAlign ? {textAlign: options.textAlign} : {})}>{text}</p>
                <button type="submit" className="btn-primary" onClick={() => proceed('this is an arguments for the proceed callback!')}>OK</button>
            </div>
        </ReactModal>
    );
};

AlertDialog.propTypes = {
    show: PropTypes.bool,            // from confirmable. indicates if the dialog is shown or not.
    proceed: PropTypes.func,         // from confirmable. call to close the dialog with promise resolved.
    cancel: PropTypes.func,          // from confirmable. call to close the dialog with promise rejected.
    dismiss: PropTypes.func,         // from confirmable. call to only close the dialog.
    title: PropTypes.string,         // arguments of your confirm function
    text: PropTypes.node,            // arguments of your confirm function
    options: PropTypes.object        // arguments of your confirm function
};

const modalDialogStyles = {
    overlay : {
        position          : 'fixed',
        top               : 0,
        left              : 0,
        right             : 0,
        bottom            : 0,
        backgroundColor   : 'rgba(0, 0, 0, 0.75)',
        zIndex            : 99999
    },
    content : {
        position                   : 'absolute',
        top                        : '40px',
        left                       : '40px',
        right                      : '40px',
        bottom                     : '40px',
        border : "0px",
        background : "none",
        overflow                   : 'auto',
        WebkitOverflowScrolling    : 'touch',
        borderRadius               : '0px',
        outline                    : 'none',
        padding                    : '20px',
        textAlign: "center"
    }
};

// confirmable HOC pass props `show`, `dismiss`, `cancel` and `proceed` to your component.
export default confirmable(AlertDialog);


// WEBPACK FOOTER //
// ./src/client/src/components/misc/AlertDialog.js